import { ChartBuilderData } from '@shared/components/chart-builder/chart-builder.component';
import { ChartType } from '@shared/charts/chart-theme';

export interface PreviewChartBuilderData {
  title: string;
  chart: {
    type: string;
    data: unknown[];
    height?: string;
    config?: Record<string, unknown>;
  };
  comments: unknown[];
  pageTitle?: {
    text: string;
    icon?: string;
  };
}

export type PreviewChartDataExtra = {
  chart?: {
    height?: string;
    config?: Record<string, unknown>;
  };
  pageTitle?: {
    text: string;
    icon?: string;
  };
};

export function buildPreviewChartData(
  chartData: {
    name?: string;
    title?: string;
    type?: string;
    data?: unknown[];
    comments?: unknown[];
    seriesNames?: unknown;
  } | null | undefined,
  fallbackTitle: string,
  fallbackType: string,
  extra?: PreviewChartDataExtra
): ChartBuilderData {
  return {
    title: chartData?.name || chartData?.title || fallbackTitle,
    chart: {
      type: (chartData?.type || fallbackType) as ChartType,
      data: (chartData?.data || []) as ChartBuilderData['chart']['data'],
      config: { fontSize: 16, ...(extra?.chart?.config || {}) },
      height: extra?.chart?.height,
    },
    comments: (chartData?.comments || []) as string[],
    ...(extra?.pageTitle ? { pageTitle: extra.pageTitle } : {}),
  };
}

export function parsePreviewLandId(value: string | number | null | undefined): number {
  const parsed = typeof value === 'number' ? value : parseInt(String(value ?? ''), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
}
